var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.masterList,"readonly":_vm.readonly,"box":_vm.readonly,"item-text":"paymentTypeName","item-value":"id","label":"支払区分","error-messages":_vm.errorHandlerMethod('paymentTypeId')},on:{"change":_vm.change},model:{value:(_vm.p_code),callback:function ($$v) {_vm.p_code=$$v},expression:"p_code"}})
}
var staticRenderFns = []

export { render, staticRenderFns }